import { ChangeRequestStatuses } from '@app/modules/change-requests/types/change-request-translatables';
import { ChangeRequestStatus } from '@change-requests/enums/change-request-status.enum';
import { ChangeRequest } from '@models/change-requests/change-request.model';
import { BadgeColumn } from '@table/classes/badge-column.class';
import { CheckListFilter } from '@table/classes/column-filters/check-list/check-list-filter.class';
import { CellDisplay } from '@table/enums/cell-display.enum';
import { BadgeDisplay } from '@table/interfaces/badge-display.interface';

export class StatusColumn extends BadgeColumn<ChangeRequest> {
    title = 'change-requests.logTable.status';
    type: CellDisplay = CellDisplay.badge;
    property = 'status';

    statusBadges: { [key: string]: BadgeDisplay } = {
        pending: { type: 'warning', label: ChangeRequestStatuses.pending },
        approved: { type: 'success', label: ChangeRequestStatuses.approved },
        denied: { type: 'danger', label: ChangeRequestStatuses.denied },
        cancelled: { type: 'danger', label: ChangeRequestStatuses.cancelled },
    };

    constructor() {
        super();

        this.filter = new CheckListFilter('status', [
            { label: ChangeRequestStatuses.pending, value: ChangeRequestStatus.Pending },
            { label: ChangeRequestStatuses.approved, value: ChangeRequestStatus.Approved },
            { label: ChangeRequestStatuses.denied, value: ChangeRequestStatus.Denied },
            { label: ChangeRequestStatuses.cancelled, value: ChangeRequestStatus.Cancelled },
        ]);
    }

    getBadgeDisplay(changeRequest: ChangeRequest): BadgeDisplay | undefined {
        return (
            this.statusBadges[changeRequest.approvalStatus] ?? {
                type: 'warning',
                label: changeRequest.approvalStatus.toUpperCase(),
            }
        );
    }
}
